import { Component, OnInit } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { Message } from '../../send-message.model';
import { DialogService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { Transport } from 'src/tmc-yard/common/model/transport.model';

@Component({
  selector: 'app-send-message-dialog',
  templateUrl: './send-message-dialog.component.html',
  styleUrls: ['./send-message-dialog.component.scss']
})
export class SendMessageDialogComponent extends AbstractWidgetComponent implements OnInit {

  messages = new Array<Message>();

  selected: Message;

  transport: Transport;

  transportHasMessaging = false;

  constructor(
    private httpService: HttpService,
    private dialogService: DialogService,
    public translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {

    this.httpService.postWithContext<Array<Message>>(environment.sendMessageEndpoint + '/getAllMessages', {}).subscribe(
      messages => {
        const result = new Array<Message>();
        for (const message of messages) {
          result.push(new Message(message));
        }
        this.messages = result;
      }
    );

  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selected-transport') {
      this.transport = contextChange.value;
      this.transportHasMessaging = this.transport != null && this.transport.messaging.messagingAvailable;
    }
  }


  onSetElementAndContext() {
    this.transport = this.dashboardContext.getContextValue('selected-transport');
    this.transportHasMessaging = this.transport != null && this.transport.messaging.messagingAvailable;
  }

  selectMessage(message: Message) {
    console.log('selectMessage', message);
    this.selected = message;
  }

  sendMessageAllTransports() {

    this.dialogService.showConfirm('tmc-yard.widget.send-message.confirm.all-transports.title', 'tmc-yard.widget.send-message.confirm.all-transports.message').afterClosed().subscribe(confirmed => {
      if (confirmed) {

        this.httpService.postWithContext<Array<Message>>(environment.sendMessageEndpoint + '/sendMessageAllTransports', { messageId: this.selected.id }).subscribe(
          response => {

          }
        );
      }
    });

  }

  sendMessageAllTransportsOnYard() {
    this.dialogService.showConfirm('tmc-yard.widget.send-message.confirm.all-transports-on-yard.title', 'tmc-yard.widget.send-message.confirm.all-transports-on-yard.message').afterClosed().subscribe(confirmed => {
      if (confirmed) {

        this.httpService.postWithContext<Array<Message>>(environment.sendMessageEndpoint + '/sendMessageAllTransportsOnYard', { messageId: this.selected.id }).subscribe(
          response => {

          }
        );
      }
    });
  }

  sendMessageCurrentTransport() {

    this.httpService.postWithContext<Array<Message>>(environment.sendMessageEndpoint + '/sendMessage', { messageId: this.selected.id, transportId: this.transport.id }).subscribe(
      response => {

      }
    );
  }
  
}
